import { Alert, Button, Stack, Typography } from '@mui/material'
import { useIsPwa } from '../../hooks/useIsPwa'
import { useWebPushSubscriptionContext } from './WebPushSubscriptionProvider'

function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

export function PushNotificationsOptIn() {
  const { state, enablePush } = useWebPushSubscriptionContext()
  const isPwa = useIsPwa()
  const showIosHint = isIosDevice() && !isPwa

  if (state === 'loading' || state === 'enabled') {
    return null
  }

  return (
    <Stack gap={1} sx={{ mb: 2 }}>
      {showIosHint && (
        <Typography variant="body2" color="text.secondary">
          На iPhone: добавьте приложение на экран «Домой».
        </Typography>
      )}

      {state === 'unsupported' && (
        <Alert severity="info">Push недоступен в этом браузере.</Alert>
      )}

      {state === 'default' && (
        <Stack direction="row" alignItems="center" gap={1}>
          <Button variant="outlined" size="small" onClick={() => void enablePush()}>
            Включить push-уведомления
          </Button>
        </Stack>
      )}

      {state === 'denied' && (
        <Alert severity="warning">Разрешите уведомления в настройках браузера.</Alert>
      )}
    </Stack>
  )
}
